export const ADMIN_SELECTED_SESSION_KEY = "adminPanelSelectedSession";
export const ADMIN_SESSION_EVENT = "admin-session-filter-changed";

export function getSelectedAdminSession() {
  return localStorage.getItem(ADMIN_SELECTED_SESSION_KEY) || localStorage.getItem("activeAcademicSession") || "All Sessions";
}

export function setSelectedAdminSession(sessionName) {
  const value = sessionName || "All Sessions";
  localStorage.setItem(ADMIN_SELECTED_SESSION_KEY, value);
  window.dispatchEvent(new Event(ADMIN_SESSION_EVENT));
}

export function sessionParam(sessionName = getSelectedAdminSession()) {
  return sessionName && sessionName !== "All Sessions" ? sessionName : "all";
}
